import UIDs from "../../../../UIDs";

const uid = UIDs.screens.bbs.default;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    REFRESH_SCREEN_ASYNC: `${uid}.refreshScreenAsync`,
    REFRESH_SCREEN_SUCCESS: `${uid}.refreshScreenSuccess`,
    REFRESH_SCREEN_FAILURE: `${uid}.refreshScreenFailure`,
    LOAD_MORE_ASYNC: `${uid}.loadMoreAsync`,
    LOAD_MORE_SUCCESS: `${uid}.loadMoreSuccess`,
    LOAD_MORE_FAILURE: `${uid}.loadMoreFailure`,
    CHANGE_SEARCH_TYPE: `${uid}.changeSearchType`,
    ADD_LIKE_ASYNC: `${uid}.addLikeAsync`,
    ADD_LIKE_SUCCESS: `${uid}.addLikeSuccess`,
    ADD_LIKE_FAILURE: `${uid}.addLikeFailure`,
    REMOVE_LIKE_ASYNC: `${uid}.removeLikeAsync`,
    REMOVE_LIKE_SUCCESS: `${uid}.removeLikeSuccess`,
    REMOVE_LIKE_FAILURE: `${uid}.removeLikeFailure`,
};

export { ActionTypes };
